import React from 'react';
import { IQueryContext } from 'framework/context/IQueryContext';
import { ICommissionPayout, ICommissionPayoutsQueryParams, IQueryResult } from 'gen/ApiClient';

export const AllQueryContext = React.createContext<IQueryContext<IQueryResult<ICommissionPayout>, ICommissionPayoutsQueryParams>>(undefined as any);
